const NotFoundPage = ()=>{
<div>
    Not NotFoundPage
</div>
}

export default NotFoundPage;
